exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".secondary-content .detail-content .program-types li{vertical-align:top}.user-education-marker{width:25px;height:25px;margin-top:5px;margin-left:auto;margin-right:auto;background:#48657f;border-bottom-right-radius:50%;border-bottom-left-radius:50%;border-top-left-radius:50%;border-top-right-radius:0;cursor:default;transform:rotate(-45deg)}.user-education-marker:after{content:\"you\";position:static;display:inline-block;height:100%;width:100%;line-height:25px;background:transparent;text-align:center;color:#fff;font-size:8px;font-weight:700;text-transform:uppercase;border-radius:0;transform:rotate(45deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/sidePanelEducation/sidePanelEducation.styl
// module id = 99
// module chunks = 0 1